(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.__productCardRelatedVariantsBound) {
    window.__productCardRelatedVariantsBound = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-related-variants-expand]');
      if (!btn) return;
      var block = btn.closest('[data-related-variants]');
      if (block) block.classList.add('related-variants--expanded');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
